const KEYS = {
  CHECKOUT_ID: "checkout_id",
  CART_TOKEN: "cart_token",
};

export const CartStorage = {
  saveCheckoutId: (checkoutId: string): void => {
    if (checkoutId) {
      localStorage.setItem(KEYS.CHECKOUT_ID, JSON.stringify(checkoutId));
    }
  },
  getCheckoutId: (): string | null => {
    return JSON.parse(localStorage.getItem(KEYS.CHECKOUT_ID) || "null");
  },

  saveCartToken: (token: string): void => {
    if (token) {
      localStorage.setItem(KEYS.CART_TOKEN, JSON.stringify(token));
    }
  },

  getCartToken: (): string => {
    return JSON.parse(localStorage.getItem(KEYS.CART_TOKEN) || "null");
  },

  clear: (): void => {
    localStorage.removeItem(KEYS.CHECKOUT_ID);
    localStorage.removeItem(KEYS.CART_TOKEN);

    Object.values(KEYS).forEach((key) => {
      localStorage.removeItem(key);
    });

    console.log("Cart storage cleared, including checkout ID");
  },
};
